import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* ✅ Wrap your entire app with HelmetProvider */}
      <App />
  </React.StrictMode>
);

// Optional: measure app performance
reportWebVitals();
